// ─────────────────────────────────────────────────────────────────────────────
// La marca de la agencia para el material que se IMPRIME o se envía.
//
// Lissette, 2026-09-03: *"el PDF sale sin el logo del perfil del agente"*.
// El recibo de nómina leía solo `Agency.logoUrl` (el que se sube en Mi Agencia
// → Marca) y ella tiene el suyo cargado en **Mi Perfil** (`User.companyLogo`,
// un data-URL base64). Con un solo sitio consultado, el papel salía sin logo
// aunque el logo estuviera cargado.
//
// Esto ya estaba resuelto en el backend (`utils/branding.ts`) y en la Ficha del
// cliente (`ClientDetail.jsx`, Lissette 2026-05-27) — cada uno con su propia
// copia de la cadena. Esta es la copia ÚNICA, para que el próximo sitio que
// imprima no repita el mismo error.
//
// El orden es el del backend, para que un mismo documento se vea igual salga
// del navegador o del servidor:
//   • logo:   Agency.logoUrl  →  User.companyLogo
//   • nombre: User.agencyDisplayName  →  Agency.name  →  User.companyName
//
// `agencyDisplayName` va PRIMERO a propósito: es el nombre con el que ese
// agente se presenta, y manda sobre el nombre compartido de la agencia (misma
// regla que `getAgencyBranding`).
// ─────────────────────────────────────────────────────────────────────────────

const texto = (v) => String(v ?? '').trim();

export function marcaDeLaAgencia(currentUser) {
  const u = currentUser || {};
  const agencia = u.agency || {};
  return {
    nombre:
      texto(u.agencyDisplayName) ||
      texto(agencia.name) ||
      texto(u.agencyName) ||
      texto(u.companyName),
    logo: texto(agencia.logoUrl) || texto(u.companyLogo),
  };
}
